import Api from 'utils/api'
import { createAsyncThunk } from '@reduxjs/toolkit'
import * as actions from './actions'

export const fetchCurrentPartner = () => async (dispatch) => {
  dispatch(actions.fetchCurrentRequest())
  try {
    const partner = await Api.request(`/service_partners/me`)
    dispatch(actions.fetchCurrentSuccess(partner))
    return Promise.resolve()
  } catch (err) {
    // Обрыв сети или HTML от балансировщика (502/504) приходят без JSON:
    // ошибку всё равно фиксируем, иначе главная ждала бы ответ вечно.
    const body =
      typeof err?.json === 'function' ? await err.json().catch(() => ({})) : {}
    dispatch(actions.fetchCurrentFailure(body?.message))
    return Promise.reject()
  }
}

export const verifyPhoneNumber = createAsyncThunk(
  'parthers/verifyPhoneNumber',
  async (phone, { getState, rejectWithValue, dispatch }) => {
    dispatch(actions.verifyPhoneNumberRequest())
    try {
      const payload = await Api.request(`/phone_confirms`, {
        method: 'POST',
        body: JSON.stringify({ phone }),
      })
      dispatch(actions.verifyPhoneNumberSuccess(payload))
      if (payload?.confirmed) {
        dispatch(fetchCurrentPartner())
      }
      return Promise.resolve(payload)
    } catch (err) {
      const { error } = await err.json()
      dispatch(actions.verifyPhoneNumberFailure(error))
      return rejectWithValue(err)
    }
  }
)

export const confirmPhoneNumber = createAsyncThunk(
  'parthers/confirmPhoneNumber',
  async ({ phone, password }, { getState, rejectWithValue, dispatch }) => {
    dispatch(actions.confirmPhoneNumberRequest())
    try {
      const payload = await Api.request(`/phone_confirms/${phone}`, {
        method: 'PATCH',
        body: JSON.stringify({ otp_code: password }),
      })
      dispatch(actions.confirmPhoneNumberSuccess())
      dispatch(fetchCurrentPartner())
      return Promise.resolve(payload)
    } catch (err) {
      const { error } = await err.json()
      dispatch(actions.confirmPhoneNumberFailure(error))
      return rejectWithValue(error)
    }
  }
)

export const createPartner = (values) => async (dispatch) => {
  dispatch(actions.createPartnerRequest())

  try {
    const payload = await Api.request(`/service_partners/update_profile`, {
      method: 'PUT',
      body: JSON.stringify(values),
    })
    dispatch(actions.createPartnerSuccess(payload?.message))
    dispatch(fetchCurrentPartner())
    return Promise.resolve()
  } catch (err) {
    const { message } = await err.json()
    dispatch(actions.createPartnerFailure(message))
    return Promise.reject()
  }
}
